export default "__VITE_ASSET__BQ6sP5kH__"